<template>
  <div class="content-max-width flex flex-between" id="wrap">

    <section class="body-container">

      <article :class="{ 'active': step === 1}">
        <legend>1. Shipping Information</legend>
        <checkout-shipping
          :countries="countries"
          :regions="regions"
          :cart="cart"
          v-on:emitStep="changeStep"
          v-show="step === 1">
        </checkout-shipping>

      </article>

      <article :class="{ 'active': step === 2}">
        <legend>2. Billing Information</legend>
        <checkout-billing
          v-show="step === 2"
          :countries="countries"
          :regions="regions"
          :cart="cart"
          v-on:emitStep="changeStep">
        </checkout-billing>
      </article>

      <article :class="{ 'active': step === 3}">
        <legend>3. Confirm Order</legend>
        <checkout-payment
          :type="'dps'"
          :countries="countries"
          :regions="regions"
          :cart="cart"
          v-on:emitStep="changeStep"
          v-show="step === 3">
        </checkout-payment>
      </article>

    </section>

    <!-- <cart-summary-component
      :cart="cart"
      :show_proceed="false"
      :show_subtotal_only="false"
    ></cart-summary-component> -->

  </div>
</template>

<script>
  export default {
    props: {
      countries: Array,
      regions: Array
    },
    data() {
      return {
        cart: {
          items: [],
          shippingInfo: {},
          billingInfo: {},
          coupons: [],
          totalAmount: 0.0,
          gstAmount: 0.0,
          shippingFree: 0.0,
          shippingDefault: 0.0,
          shippingAmount: 0.0,
          couponAmount: 0.0,
          subTotalAmount: 0.0,
          gstPercent: 0.0,
          hasFreightCalculations: true,
          hasFreightRegionLookup:true,
          gstInclusive: false,
        },
        step: 1
      }
    },
    mounted() {
      this.loadCart()
    },
    methods: {
      loadCart () {
        this.$store.commit('setLoading', true)

        window.axios.get('/cart?ajax=1')
          .then((res) => {
            this.$store.commit('setCart', res.data.data)
            this.cart = this.$store.state.cart
          })
          .catch((error) => {
            this.$store.commit('setLoading', false)
            this.$store.commit('setPopup', {
              open: true,
              content: '<p>We could not find your cart. Please try again.</p>'
            })
          })
          .then(() => {
            this.$store.commit('setLoading', false)
          })
      },

      changeStep (toStep) {
          console.log('change step', toStep)
        this.loadCart()
        this.step = toStep
      }
    }
  }
</script>

<style lang="scss">
@import "../../sass/core/variables.scss";

.body-container {
  width: 50%;
  margin-bottom: 50px;

  @media (max-width: $mediumish) {
    width: 100%;
  }

    article {
      max-width: 800px;
      margin: 0 0 10px;
      padding: 10px;

      background: $color-1;
      border-radius: 4px;

      legend {
        margin: 0;
        padding: 0 10px;

        font-size: 18px;
        color: white;
      }

      .checkout-step-footer {
        width: 100%;
        display: inline-block;
        margin-top: 20px;

        .button {
          margin-bottom: 10px;
          border: 1px solid $color-1;
          color: $color-1;

          transition: all .3s ease-in;

          &:hover {
              background: $color-1;
              color: white;
              transition: all .3s ease-in;
              cursor: pointer;
          }
        }
      }
    }

    article.active {
      padding: 10px 20px;

      background: #f9f9f9;

      legend {
        margin: 10px 0 10px;
        padding: 0;
        color: $color-1;
      }

      button {
        cursor: pointer;
      }
    }
}

#wrap {
  .cart-summary {
    margin-top: 0;
    margin-bottom: 50px;
  }
}

.message {
  height: 120px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-cart/Checkout.vue